import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterListTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FilterListTwoTone.js
// module id = 3654
// module chunks = 2